var FooterMenuItems = function () {
  if (window.matchMedia("(max-width: 800px)").matches) {
    const footerHeadings = document.querySelectorAll(
      ".footer__blocks-wrapper .footer-block--menu .footer-block__heading"
    );
    footerHeadings.forEach((heading) => {
      heading.addEventListener("click", () => {
        const detailsContent = heading.nextElementSibling;
        if (
          detailsContent.style.display === "none" ||
          detailsContent.style.display === ""
        ) {
          detailsContent.style.display = "block";
          heading.classList.add("open");
        } else {
          detailsContent.style.display = "none";
          heading.classList.remove("open");
        }
      });
    });
  }
};
var MegaMenuDisplayOnHover = function () {
  $(".mega-menu-li").on("mouseenter", function () {
    $(".mega-menu").removeAttr("open");
    $(".mega-menu .header__menu-item").removeAttr("aria-expanded");
    $(this)
      .find(".mega-menu")
      .attr("open", true)
      .find(".header__menu-item")
      .attr("aria-expanded", true);
  });
  $("ul.list-menu.list-menu--inline > li:not(.mega-menu-li)").on(
    "mouseenter",
    function () {
      $(".mega-menu").removeAttr("open");
      $(".mega-menu .header__menu-item").removeAttr("aria-expanded");
    }
  );
  $(".mega-menu__content").on("mouseleave", function () {
    $(".mega-menu").removeAttr("open");
    $(".mega-menu .header__menu-item").removeAttr("aria-expanded");
  });
};


FooterMenuItems();
MegaMenuDisplayOnHover();
$(document).on("shopify:section:load", function (event) {
  FooterMenuItems();
  MegaMenuDisplayOnHover();
});

  $(".customModelButton").on('click', function(e) {
    e.preventDefault();
  $(".custom-model-main").addClass('model-open');
}); 
$(".close-btn, .bg-overlay").click(function(e){
  e.preventDefault();
  $(".custom-model-main").removeClass('model-open');
});




// product page tabs code 

$(document).ready(function() {
  $('#productInfo ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
});
const accordionBtns = document.querySelectorAll("#productinfo-mobile .accordion");
  accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    this.classList.toggle("is-open");
    let content = this.nextElementSibling;
    console.log(content);
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
        content.style.maxHeight = content.scrollHeight + "px";
      console.log(content.style.maxHeight);
    }
  };
});

